jQuery(document).foundation()
